/**
 * #386 — useMonitoringCredentials hook.
 * Fetches Grafana viewer credentials from BE.
 * Available to any authenticated user (operator decision: monitoring card shown to all logged-in users).
 * On failure (e.g. 401) it fails silently — `retry: false`, data stays null.
 */
import { useQuery } from '@tanstack/react-query';
import { monitoringApi } from '../api/monitoringApi';
import type { MonitoringCredentials } from '../api/monitoringApi';

export function useMonitoringCredentials() {
  return useQuery<MonitoringCredentials | null>({
    queryKey: ['_index', 'monitoring', 'credentials'],
    queryFn: () => monitoringApi.getCredentials(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  });
}
